import { render, staticRenderFns } from "./PromoSitesPicker.vue?vue&type=template&id=5becbb7b&lang=pug&"
import script from "./PromoSitesPicker.vue?vue&type=script&lang=js&"
export * from "./PromoSitesPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports